// src/protocols/assemblies.js — протоколи от Общо събрание + печат (Фаза 3.2).

// $ липсваше в импорта: след „Запази"/„Изтрий" опресняването гърмеше с
// „$ is not defined" — записът минаваше, но излизаше грешка и списъкът
// оставаше стар (грешка от картата, 16.10.2026).
import { el, clear, $, field, input, row, clickableRow } from '../shared/dom.js';
import { numberLine } from '../shared/docNumber.js';
import { dateInput, localTodayIso, guardDates } from '../shared/dates.js';
import { dfmt } from '../shared/format.js';
import { toast } from '../shared/toast.js';
import { api } from '../shared/api.js';
import { emptyState, docNo } from '../shared/ui.js';
import { openModal, closeModal, confirmDialog } from '../shared/modal.js';
import { auditBlock } from '../shared/audit.js';
import { bulkManager } from '../shared/pickers.js';
import { state, cq, activeCompanyObj, isAdminUser } from '../shared/state.js';
import { sortTh, sortLabel } from '../shared/sortHeader.js';
import { regHead, regFilters, regField, regCount, REG_TABLE } from '../shared/register.js';

const ASM_TYPE = { sole: 'Решение на едноличния собственик', general: 'Общо събрание на съдружниците' };
let _assemblies = [];

export async function view(host) {
  clear(host);
  let rows = [];
  try { rows = await api('/assemblies' + cq()); } catch (e) { toast(e.message, true); }
  _assemblies = rows;
  const panel = el('div', { class: 'panel' });
  const bulk = bulkManager({ endpoint: '/assemblies', refresh: () => window.CRM.renderView($('#page')), label: 'протокола' });
  // Видът е като в „Доставки" (Макс, 29.10.2026) — общите парчета от register.js.
  const head = regHead('Протоколи от Общо събрание', [],
    el('button', { class: 'btn sm', type: 'button', text: '+ Нов протокол', onClick: () => assemblyForm(null) }),
    bulk.toolbar);
  panel.appendChild(head);
  if (!rows.length) { panel.appendChild(emptyState('▤', 'Още няма протоколи от общо събрание.', '+ Нов протокол', () => assemblyForm(null))); host.appendChild(panel); return; }
  const flt = { q: '', year: '', sortKey: 'number', sortDir: 'desc' };
  const years = [...new Set(rows.map((p) => (p.protocol_date || '').slice(0, 4)).filter(Boolean))].sort().reverse();
  const search = input({ type: 'search', placeholder: 'Търси №…', 'aria-label': 'Търси №' });
  search.addEventListener('input', () => { flt.q = search.value.toLowerCase(); draw(); });
  const yearSel = el('select', { 'aria-label': 'Година', onChange: (e) => { flt.year = e.target.value; draw(); } }, el('option', { value: '', text: 'Всички години' }), ...years.map((y) => el('option', { value: y, text: y })));
  // Търси се и по вида („Решение на едноличния…"), затова надписът го казва.
  panel.appendChild(regFilters(regField('№ или вид', search, 'l'), regField('Година', yearSel)));
  const countLbl = regCount();
  panel.appendChild(countLbl);
  const numOf = (p) => parseInt(String(p.number || '').replace(/\D/g, ''), 10) || 0;
  function setSort(k) { if (flt.sortKey === k) flt.sortDir = flt.sortDir === 'asc' ? 'desc' : 'asc'; else { flt.sortKey = k; flt.sortDir = 'asc'; } draw(); }
  const thNo = sortTh({}, () => setSort('number'));
  const thTy = el('th', { scope: 'col' });
  const thDt = sortTh({ class: 'hide-sm' }, () => setSort('date'));
  const tb = el('tbody');
  function draw() {
    bulk.reset(); clear(tb);
    let r = rows.filter((p) => {
      if (flt.year && (p.protocol_date || '').slice(0, 4) !== flt.year) return false;
      if (flt.q) { if (!(((p.number || '') + ' ' + (ASM_TYPE[p.meeting_type] || '')).toLowerCase().includes(flt.q))) return false; }
      return true;
    });
    const dir = flt.sortDir === 'asc' ? 1 : -1;
    r.sort((a, b) => { if (flt.sortKey === 'date') { const x = a.protocol_date || '', y = b.protocol_date || ''; return x < y ? -dir : x > y ? dir : 0; } return (numOf(a) - numOf(b)) * dir; });
    r.forEach((p) => { tb.appendChild(clickableRow(() => assemblyForm(p), 'Отвори протокол № ' + p.number, bulk.cell(p.id, 'протокол № ' + p.number), el('td', { style: 'font-weight:600' }, '№ ', docNo(p.number)), el('td', {}, ASM_TYPE[p.meeting_type] || '—'), el('td', { class: 'hide-sm' }, dfmt(p.protocol_date)))); });
    sortLabel(thNo, '№', flt.sortKey === 'number' ? flt.sortDir : ''); thTy.textContent = 'Вид'; sortLabel(thDt, 'Дата', flt.sortKey === 'date' ? flt.sortDir : ''); countLbl.set(r.length, rows.length, flt.q);
  }
  panel.appendChild(el('table', { class: REG_TABLE }, el('thead', {}, el('tr', {}, bulk.headTh, thNo, thTy, thDt)), tb));
  draw(); host.appendChild(panel);
}

function assemblyForm(existing) {
  const a = existing || {};
  const company = activeCompanyObj() || {};
  const f = {
    meeting_type: el('select', {}, ...Object.keys(ASM_TYPE).map((k) => el('option', { value: k, text: ASM_TYPE[k], selected: (a.meeting_type || 'sole') === k }))),
    protocol_date: dateInput(a.protocol_date || localTodayIso()),
    place: input({ value: a.place || company.city || 'София' }),
    present: el('textarea', { placeholder: 'Присъстващи / съдружници и дялове…' }, a.present || ''),
    agenda: el('textarea', { placeholder: 'Дневен ред (по точки)…' }, a.agenda || ''),
    decisions: el('textarea', { placeholder: 'Решения по точките…' }, a.decisions || ''),
    chairman: input({ value: a.chairman || company.mol || '' }),
    secretary: input({ value: a.secretary || '' }),
    notes: el('textarea', { placeholder: 'Бележки…' }, a.notes || ''),
  };
  const body = el('div', {},
    numberLine('/assemblies', 'Новият протокол', existing),
    row(field('Вид', f.meeting_type), field('Дата', f.protocol_date)),
    field('Място на провеждане', f.place),
    field('Присъстващи', f.present),
    field('Дневен ред', f.agenda),
    field('Решения', f.decisions),
    row(field('Председател', f.chairman), field('Протоколчик', f.secretary)),
    field('Бележки', f.notes)
  );
  if (existing && existing.id) { const _ab = auditBlock(existing); if (_ab) body.appendChild(_ab); }
  const save = async () => {
    // Неразбрана дата не тръгва празна — сървърът би сложил днешна (ПРОМТ-19).
    if (!guardDates(f.protocol_date)) return;
    const p = { company_id: state().activeCompany };
    for (const k in f) p[k] = ('iso' in f[k].dataset) ? f[k].dataset.iso : f[k].value;
    try { if (existing && existing.id) await api('/assemblies/' + existing.id, { method: 'PUT', body: JSON.stringify(p) }); else await api('/assemblies', { method: 'POST', body: JSON.stringify(p) }); closeModal(); toast('Записано.'); window.CRM.renderView($('#page')); } catch (e) { toast(e.message, true); }
  };
  const foot = el('div', { style: 'flex-wrap:wrap' });
  if (existing && existing.id) {
    // „Създай подобен": нов протокол със същите присъстващи, дневен ред и
    // решения — типичният случай са редовните събрания с еднакъв състав.
    // Без id/номер (броячът дава номера при „Запази"); датата става днешна.
    foot.appendChild(el('button', { class: 'btn sm ghost copy-btn', text: 'Създай подобен', title: 'Нов протокол със същите присъстващи и дневен ред', style: 'margin-right:auto', onClick: () => {
      closeModal();
      assemblyForm({
        meeting_type: existing.meeting_type,
        place: existing.place,
        present: existing.present,
        agenda: existing.agenda,
        decisions: existing.decisions,
        chairman: existing.chairman,
        secretary: existing.secretary,
        notes: existing.notes,
      });
    } }));
    foot.appendChild(el('button', { class: 'btn sm ghost', text: 'Печат / PDF', onClick: () => printAssembly(existing) }));
    if (isAdminUser()) foot.appendChild(el('button', { class: 'btn sm danger', text: 'Изтрий', onClick: async () => { if (await confirmDialog('Да изтрия ли този протокол?', { okText: 'Изтрий', danger: true })) { try { await api('/assemblies/' + existing.id, { method: 'DELETE' }); closeModal(); toast('Изтрито.'); window.CRM.renderView($('#page')); } catch (e) { toast('Изтриването не се получи. ' + e.message, true); } } } }));
  }
  foot.appendChild(el('button', { class: 'btn ghost', text: 'Отказ', onClick: closeModal }));
  foot.appendChild(el('button', { class: 'btn', text: 'Запази', onClick: save }));
  openModal({ title: existing && existing.id ? 'Протокол ОС № ' + existing.number : 'Нов протокол от общо събрание', body, foot, wide: true });
}

function printAssembly(a) {
  // Фирмата — каквато е била при създаването на протокола (parties.seller),
  // не днешната карта: стар протокол не бива да излиза с новия адрес/МОЛ.
  const company = Object.assign({}, activeCompanyObj() || {}, (a && a.parties && a.parties.seller) || {});
  let area = document.getElementById('print-area');
  if (!area) { area = el('div', { id: 'print-area' }); document.body.appendChild(area); }
  clear(area);
  const title = a.meeting_type === 'general' ? 'ПРОТОКОЛ ОТ ОБЩО СЪБРАНИЕ НА СЪДРУЖНИЦИТЕ' : 'ПРОТОКОЛ-РЕШЕНИЕ НА ЕДНОЛИЧНИЯ СОБСТВЕНИК НА КАПИТАЛА';
  const para = (label, text) => text ? el('div', { style: 'margin:12px 0' }, el('div', { style: 'font-weight:700;margin-bottom:3px', text: label }), el('div', { style: 'white-space:pre-wrap', text: text })) : null;
  area.appendChild(el('div', { class: 'inv' },
    el('div', { class: 'inv-top' },
      el('div', { class: 'firm' }, el('h2', { text: company.name || 'Фирма' }), company.eik ? el('div', { text: 'ЕИК: ' + company.eik }) : null, el('div', { text: company.city || '' })),
      el('div', { class: 'meta' }, el('div', { class: 'big', text: 'ПРОТОКОЛ' }), el('div', { text: '№ ' + a.number }), el('div', { text: 'Дата: ' + dfmt(a.protocol_date) }), a.place ? el('div', { text: 'Място: ' + a.place }) : null)
    ),
    el('h3', { style: 'text-align:center;margin:16px 0', text: title }),
    para('Присъстващи:', a.present),
    para('Дневен ред:', a.agenda),
    para('Решения:', a.decisions),
    para('Бележки:', a.notes),
    el('div', { class: 'inv-sign', style: 'margin-top:36px' }, el('div', { text: 'Председател: ' + (a.chairman || '……………………') }), el('div', { text: 'Протоколчик: ' + (a.secretary || '……………………') }))
  ));
  const after = () => { area.style.display = 'none'; window.removeEventListener('afterprint', after); };
  window.addEventListener('afterprint', after);
  area.style.display = 'block';
  setTimeout(() => window.print(), 60);
}

